import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/storybook-components';
import {TABS} from '../ModalWindow.utils';
import {MCStateContext} from '../..';
import {useTranslation} from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY_DONE = 'Done.string';
const TRANSLATION_KEY_NEXT = 'Next.string';

export function DoneButton(props) {
  const {balanced, isLidOpen, running, playbackComplete} =
    React.useContext(MCStateContext);

  const {t} = useTranslation();

  const isValid = () => {
    switch (props.currentTab) {
      case TABS.TOP_VIEW:
        return balanced && !isLidOpen;
      case TABS.FRONT_VIEW:
        return !running && playbackComplete;
    }
  };

  const invalidFlag = isValid() ? '' : '--invalid';
  const className = ` mc_doneButton${invalidFlag} ${props.className}`;

  const onClick = () => {
    if (props.currentTab === TABS.TOP_VIEW && isValid())
      props.setCurrentTab(TABS.FRONT_VIEW);
    else if (props.currentTab === TABS.FRONT_VIEW && isValid())
      props.closeModal();
  };

  return (
    <Button className={className} onClick={onClick}>
      {(props.currentTab === TABS.TOP_VIEW)?t(TRANSLATION_KEY_NEXT):t(TRANSLATION_KEY_DONE)}
    </Button>
  );
}

DoneButton.propTypes = {
  /**
   * classname for component
   */
  className: PropTypes.string,
  /**
   * callback function to set tab view
   */
  setCurrentTab: PropTypes.func,
  /**
   * tells the current tab open
   */
  currentTab: PropTypes.string,
  /**
   * callback function to close modal
   */
  closeModal: PropTypes.func,
};
